<template>
  <div class="card border p-1 mb-1">
    <div class="d-flex align-items-start justify-content-between">
      <div class="d-flex align-items-center">
        <Avatar :user="comment.user" />
        <div>
          <div class="d-flex align-items-center">
            <span class="font-weight-bolder">{{ fullName }}</span>
            <b-badge
              :variant="comment.isReview ? 'warning' : 'secondary'"
              class="ml-1"
            >
              {{ comment.isReview ? 'Отзыв' : 'Комментарий' }}
            </b-badge>
            <b-badge
              v-if="comment.isReview && comment.averageScore != null"
              variant="info"
              class="ml-50"
            >
              {{ formatScore(comment.averageScore) }}
            </b-badge>
            <b-badge
              v-if="comment.isQuestion"
              :variant="comment.isAnswered ? 'success' : 'danger'"
              class="ml-50"
            >
              {{ comment.isAnswered ? 'Вопрос · отвечено' : 'Вопрос · нужен ответ' }}
            </b-badge>
          </div>
          <div>{{ formatDate(comment.createdAt) }}</div>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <span>{{
          comment.start && comment.start.name
            ? comment.start.name
            : 'Без старта'
        }}</span>
        <b-button
          size="sm"
          :variant="comment.isQuestion && !comment.isAnswered ? 'primary' : 'outline-secondary'"
          class="ml-1"
          @click="isAnswering = !isAnswering"
        >
          Ответить
        </b-button>
        <b-button
          size="sm"
          variant="outline-primary"
          class="ml-1"
          @click="isEditing = true"
        >
          Редактировать
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          class="ml-1"
          @click="deleteComment"
        >
          Удалить
        </b-button>
      </div>
    </div>

    <CommentEditForm
      v-if="isEditing"
      :initial-text="comment.comment"
      @save="saveEdit"
      @cancel="isEditing = false"
    />

    <p
      v-else
      class="mt-1"
    >
      {{ comment.comment }}
    </p>

    <!-- an administrator's reply answers a question: it leaves the queue -->
    <CommentEditForm
      v-if="isAnswering"
      initial-text=""
      @save="sendAnswer"
      @cancel="isAnswering = false"
    />

    <div
      v-if="comment.replies && comment.replies.length"
      class="replies mt-2"
    >
      <details>
        <summary class="mb-1 cursor-pointer">
          Показать ответы ({{ comment.replies.length }})
        </summary>
        <SubCommentItem
          v-for="reply in comment.replies"
          :key="reply.id"
          :comment-id="comment.id"
          :reply="reply"
          @refresh="$emit('refresh')"
        />
      </details>
    </div>
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue'
import Avatar from './Avatar.vue'
import CommentEditForm from './CommentEditForm.vue'
import SubCommentItem from './SubCommentItem.vue'

export default {
  name: 'CommentItem',
  components: { BButton, BBadge, Avatar, CommentEditForm, SubCommentItem },
  props: { comment: Object },
  data() {
    return { isEditing: false, isAnswering: false }
  },
  computed: {
    fullName() {
      const u = this.comment.user
      return u ? `${u.name} ${u.surname}` : 'Неизвестный пользователь'
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString('ru-RU')
    },
    formatScore(score) {
      const n = Number(score)
      return Number.isNaN(n) ? score : n.toFixed(1)
    },
    async deleteComment() {
      try {
        await this.$http.delete(`comment/${this.comment.id}`)
        this.$emit('refresh')
      } catch (err) {
        console.error('Ошибка при удалении комментария:', err)
      }
    },
    async sendAnswer(text) {
      if (!text.trim()) return
      try {
        await this.$http.post('comment/sub-comment', {
          comment: text,
          parentCommentId: String(this.comment.id),
          ...(this.comment.start ? { startId: String(this.comment.start.id) } : {}),
        })
        this.isAnswering = false
        this.$emit('refresh')
      } catch (err) {
        console.error('Ошибка при отправке ответа:', err)
      }
    },
    async saveEdit(newText) {
      if (!newText.trim()) return
      try {
        await this.$http.patch(`comment/${this.comment.id}`, {
          comment: newText,
          isReview: Boolean(this.comment.isReview),
        })
        this.comment.comment = newText
        this.isEditing = false
      } catch (err) {
        console.error('Ошибка при сохранении комментария:', err)
      }
    },
  },
}
</script>
